import { render } from "./Client.vue?vue&type=template&id=498b6fd7&scoped=true&ts=true"
import script from "./Client.vue?vue&type=script&lang=ts"
export * from "./Client.vue?vue&type=script&lang=ts"

import "./Client.vue?vue&type=style&index=0&id=498b6fd7&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498b6fd7"]])

export default __exports__